import { FaCartShopping, FaComputer, FaWallet } from "react-icons/fa6";
import { HiShoppingBag } from "react-icons/hi2";
import { MdBusinessCenter, MdDashboard } from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { FaUserCog, FaCode, FaCreditCard } from "react-icons/fa";
import { BsCalendar2EventFill } from "react-icons/bs";
import { GiWallet } from "react-icons/gi";
import { HiReceiptRefund } from "react-icons/hi2";
import { MdDeliveryDining } from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import { RiShoppingBag3Fill } from "react-icons/ri";

export const getSidebarMenus = (activeBusiness, userBusinesses) => {
  const activeBusinessObject = userBusinesses?.find(
    (business) => business.id === activeBusiness
  );
  const categories = activeBusinessObject?.Categories?.map((category) =>
    category.categoryName.toLowerCase()
  );

  return [
    {
      title: "Dashboard",
      route: "/dashboard",
      icon: <MdDashboard className="text-xl" />,
      permission: "Dashboard",
    },
    {
      title: "Business Management",
      route: "/business-management",
      icon: <MdBusinessCenter className="text-xl" />,
      permission: "Business Management",
    },
    {
      // title: "Product Orders",
      title: "Transactions",
      route: "/orders",
      // icon: <FaCartShopping className="text-lg" />,
      icon: <GrTransaction className="text-lg" />,
      permission: "Orders & Transactions",
    },

    // categories?.includes("delivery") && {
    //   title: "Delivery",
    //   route: "/delivery",
    //   icon: <MdDeliveryDining className="text-xl" />,
    //   permission: "3",
    // },

    categories?.includes("shopping") && {
      title: "Shopping",
      route: "/products",
      icon: <RiShoppingBag3Fill className="text-xl" />,
      permission: "Orders & Transactions",
    },

    categories?.includes("event") && {
      title: "Events",
      route: "/events",
      icon: <BsCalendar2EventFill className="text-xl" />,
      permission: "Orders & Transactions",
    },

    {
      title: "Refund Requests",
      route: "/refunds",
      icon: <HiReceiptRefund className="text-xl" />,
      permission: "System Management",
    },
    {
      title: "Wallet",
      route: "/wallet",
      icon: <GiWallet className="text-xl" />,
      permission: "Wallet",
    },
    {
      title: "System Management",
      icon: <FaComputer className="text-xl" />,
      parentRoute: "/system",
      permission: "System Management",
      children: [
        {
          title: "User Management",
          route: "/system/user-management",
          icon: <FaUserCog className="text-xl" />,
          permission: "User Management",
        },
        {
          title: "Roles & Permissions",
          permission: "Roles & Permissions",
          route: "/system/permissions",
        },
        {
          title: "Audit Logs",
          permission: "System Management",
          route: "/system/auditlogs",
        },
      ],
    },
    {
      title: "Reports & Analytics",
      route: "/reports",
      icon: <BiSolidReport className="text-xl" />,
      permission: "Reports & Analytics",
    },
    {
      title: "Integrations",
      icon: <FaCode className="text-xl" />,
      parentRoute: "/integrations",
      permission: "Dashboard",
      children: [
        {
          title: "Payment Settings",
          route: "/payment-integration",
          icon: <FaCreditCard className="text-base" />,
          permission: "Dashboard",
        },
        {
          title: "Integration Guide",
          route: "/integration-guide",
          icon: <FaCode className="text-base" />,
          permission: "Dashboard",
        },
      ],
    },
  ].filter(Boolean);
};
